import component from './ApplyFooter';

export default component;
